/* template */
<template minapp="mpx" xlang="wxml"><div class="guide"><div class="time-container"><div v-for="(item, index) in (guide.list)" class="time">{{ item.time }}</div></div><div class="tips-container"><div v-for="(item, index) in (guide.list)"><div :class="(item && item.tips ? 'tips' : 'tips-empty')" :style="[(item.tips ? {} : index === 0 ? {'margin-right': '26px'} : index === 4 ? {'margin-left': '26px'}:index === 2&&orderDetail ? {'margin-left': '-3px'}:{}),(item.tips ? tipsBackground:circleStyle)] | transRpxStyle" v-if="(item.station)">{{item.tips}}</div><div :class="(item.text ? '' : 'tips-line-empty')" :style="[(lineStyle)] | transRpxStyle" class="tips-line" v-else-if="(index === 1)"><div :style='[(textStyle),"left:18vw"] | transRpxStyle' class="tips-text" v-if="(item.text)">{{ item.text }}</div></div><div :class="(item.text ? '' : 'tips-line-empty')" :style="[(lineStyle)] | transRpxStyle" class="tips-line-second" v-else-if="(index === 3)"><div :style='[(textStyle),"right:18vw"] | transRpxStyle' class="tips-text" v-if="(item.text)">{{ item.text }}</div></div></div></div><div :style="[(stationFont)] | transRpxStyle" class="station-container"><div v-for="(item, index) in (guide.list)" :class="(item.tips ? 'station' : 'station-empty')" :style="[(stationStyle),(index == 0?'text-align:left':index==2?'text-align:center':index==4?'text-align:right':'')] | transRpxStyle">{{
        item.station
      }}</div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0bb010cb"}'>
  @import '~@/mixins/stylus/color.styl'

  .time-container
    display flex
    justify-content space-between
    font-size 32px
    color #222222
    font-family Barlow Semi Condensed
    font-weight 400
    .time
      min-width 20%
  .tips-container
    font-size 10px
    font-weight 600
    display flex
    align-items center
    justify-content space-between
    color #338FFF
    position relative
    margin-top 2px
    margin-bottom 4px
    .tips
      border var(--tips-border)
      border-radius 137.5px
      z-index 2
      background var(--tips-background)
      position relative
      width 36px
      height 19px
      font-size 10px
      text-align center
      line-height 19px
      font-weight 600
    .tips-empty
      border 3px solid var(--circle-border)
      border-radius 50%
      padding 4px
      z-index 2
      background  var(--circle-background)
      position relative
    .tips-line
      position absolute
      background var(--line-color)
      background-position center
      height 5px
      width 50%
      top 8px
      left 8px
      z-index 1
    .tips-line-second
      position absolute
      background var(--line-color)
      background-position center
      height 5px
      width 50%
      top 8px
      right 8px
      z-index 1
    .tips-line-empty
      background var(--line-empty)
    .tips-text
      position absolute
      top -8px
      background var(--text-background)
      border-radius 103px
      color var(--text-color)
      width 52px
      height 19px
      font-size 10px
      text-align center
      line-height 19px
      border var(--text-border)
  .station-container
    display flex
    font-size var(--station-size)
    justify-content space-between
    font-weight 400
    .station
      flex 1
      color var(--station-color)
    .station-empty
      flex 1
      color var(--station-empty)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0bb010cb"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./more-less-guide.mpx.js?isComponent&outputPath=components%2Fmore-less-guide0bb010cb%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./more-less-guide.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fmore-less-guide0bb010cb%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0bb010cb"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/more-less-guide0bb010cb/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
